<script>

import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "RawReportData",
  components: {ActiveApiCalls},
  permissions: ['Access Raw Reports Data'],
  methods: {
    loadAll() {
      return this.$BwfApi.get("raw-report-data").then(response => {
        this.data = response

        for (const folderName in this.data) {
          this.data[folderName].sort((a, b) => {
            return b.localeCompare(a)
          })
        }
      })
    },
    downloadFile(folderName) {
      if (this.selectedFile) {
        console.log(folderName, this.selectedFile)
        this.$BwfApi.get("raw-report-data/download", {folderName: folderName, reportName: this.selectedFile},
            {responseType: "blob"}
        ).then(response => {
          const objectUrl = window.URL.createObjectURL(response)
          const anchor = document.createElement("a")
          document.body.appendChild(anchor)
          anchor.target = "_blank"
          anchor.href = objectUrl
          anchor.download = this.selectedFile
          anchor.click()
        })
      }
    },
  },
  computed: {
    folderNames() {
      return Object.keys(this.data)
    },
    coreNames() {
      return this.folderNames.filter(name => this.core.includes(name))
    },
    nonCoreNames() {
      return this.folderNames.filter(name => !this.core.includes(name))
    },
  },
  mounted() {
    this.loadAll()
  },
  data() {
    return {
      data: [],
      selectedFile: null,
      core:["Master Report"]
    }
  },
}
</script>

<template>
  <v-container fluid>
    <h1 class="display-inline">Raw Report Data</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <p>Download raw report data</p>
    <h3 class="mt-4 mb-2">Core</h3>
    <v-expansion-panels>
      <v-expansion-panel v-for="folderName in coreNames" :key="folderName">
        <v-expansion-panel-header>{{ folderName }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-select
              v-model="selectedFile"
              :items="data[folderName]"
              label="Raw Data"
              item-text="name"
              item-value="name"
              @input="downloadFile(folderName)"
          ></v-select>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <h3 class="mt-6 mb-2">Non-core</h3>
    <v-expansion-panels>
      <v-expansion-panel v-for="folderName in nonCoreNames" :key="folderName">
        <v-expansion-panel-header>{{ folderName }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-select
              v-model="selectedFile"
              :items="data[folderName]"
              label="Raw Data"
              item-text="name"
              item-value="name"
              @input="downloadFile(folderName)"
          ></v-select>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<style scoped>

</style>